export default __webpack_public_path__ + "static/media/Settings.3e333355.svg";